<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='inventoryclasss' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white fh" id='inventoryclasss-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange"
                  row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :load="load" lazy
        >
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else>
                    <span
                      v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                        scope.row[item.key] | dateFormat
                      }}</span>
                    <span v-else>{{ scope.row[item.key] }}</span>
                  </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="inventoryclasss-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData"
                    :soltNameArray="soltNameArray">
        <!-- multiple:是否多选      open-on-click：点击触发   open-on-focus：获得焦点时触发   clear-on-select：清除之前被选的 -->
        <treeselect slot="parentCode" :normalizer="normalizer" :options="modulesTreeRoot"
                    :default-expand-level="3" :multiple="false" :open-on-click="true" :open-on-focus="true"
                    :clear-on-select="true"
                    v-model="dpSelectModule"></treeselect>
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="inventoryclasss-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp"
                     :soltNameArray="soltNameArray">
        <treeselect slot="parentCode" :normalizer="normalizer" :options="modulesTreeRoot"
                    :default-expand-level="3" :multiple="false" :open-on-click="true" :open-on-focus="true"
                    :clear-on-select="true"
                    v-model="dpSelectModule"></treeselect>
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
    </div>
  </div>
</template>

<script>
import * as inventoryclasss from '@/api/inventoryclasss';
import mytable from '@/utils/crmtableFlowV2';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'inventoryclasss',
  components: { Treeselect },
  mixins: [mytable],
  data() {
    return {
      crmType: 'Inventoryclass',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: '',
        parentCode: ''
      },
      rules: {},
      normalizer(node) {
        // treeselect定义字段
        return {
          label: node.cInvCName,
          id: node.cInvCCode,
          children: node.children
        };
      },
      modules: [],
      modulesTree: [], // 用户可访问到的所有模块组成的树
      soltNameArray: ['parentCode']
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  computed: {
    modulesTreeRoot() {
      const root = [{
        cInvCName: '根节点',
        parentCode: '',
        id: '',
        cInvCCode: ''
      }];
      return root.concat(this.modulesTree);// 用户可访问到的所有模块组成的树
    },
    dpSelectModule: {
      // 模块编辑框下拉选中的模块
      get: function() {
        if (this.dialogFormVisible) {
          return this.initData.parentCode;
        } else {
          return this.temp.parentCode;
        }
      },
      set: function(v) {
        // 如果是根节点
        if (v === undefined || v === null || !v) {
          if (this.dialogFormVisible) {
            this.initData.parentCode = null;
            this.$refs['dataForm'].$refs['frmData'].AssignmentModel('parentCode', null);
          } else {
            this.$refs['editForm'].$refs['frmEditData'].AssignmentModel('parentCode', null);
          }
          return;
        }
        if (this.dialogFormVisible) {
          this.$refs['dataForm'].$refs['frmData'].AssignmentModel('parentCode', v);
        } else {
          this.$refs['editForm'].$refs['frmEditData'].AssignmentModel('parentCode', v);
        }
      }
    }
  },
  methods: {
    getApi() {
      return inventoryclasss;
    },
    // beforCreate() {
    //
    // },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'inventoryclasss') {
        this.drawertemp = { ...this.drawertemp, ...row };
        this.menukeyArray = [
          { name: '', menukey: 'inventoryclasssview' }
        ]; // 要显示的标签
        this.drawer = true;
      }
    },

    load(tree, treeNode, resolve) {
      inventoryclasss.getChildrenData(tree.cInvCCode).then(res => {
        resolve(res.result);
      });
    },
    getModulesTree() {
      var _this = this; // 记录vuecomponent
      inventoryclasss.getAllData().then(response => {
        _this.modules = response.result.map(function(item) {
          return {
            id: item.id,
            cInvCCode: item.cInvCCode,
            cInvCName: '(' + item.cInvCCode + ')' + item.cInvCName,
            parentCode: item.parentCode
          };
        });
        var modulestmp = _this.modules.map(o => ({ ...o }));
        _this.modulesTree = _this.$utils.toArrayTree(modulestmp, {
          key: 'cInvCCode',
          parentKey: 'parentCode',
          strict: true
        });
      });
    },
    beforCreate() {
      this.getModulesTree();
      if (this.multipleSelection.length > 0) {
        this.initData.parentCode = this.multipleSelection[0].cInvCCode;
      } else {
        this.initData.parentCode = '';
      }
    },
    beforUpdate() {
      this.getModulesTree();
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#inventoryclasss-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}
</style>
